import AddTeamForm from "../../forms/teams/AddTeamForm"
import UpdateTeamForm from "../../forms/teams/UpdateTeamForm"
import closeIcon from "../../assets/icon/close.svg"
import {useTranslation} from "react-i18next"
import {useNwDashboardContext} from "../../reactContext/contextCustomHooks/useNwDashboardContext"

export default function NeurowideDashboardModal({team, type, mutateTeams, mutateTeam, mutateTeamOverview}) {
    const {t} = useTranslation()
    const {nwDashboardContext, setNwDashboardAction} = useNwDashboardContext()
    return (
        <>
        <div className={`neurowide-dashboard-modal ${nwDashboardContext.isModal && "open"}`}>
            <h2>{type === "add" ? `${t("New licence")}` : team.team.name}</h2>
            <img className="close" src={closeIcon} alt="" onClick={() => setNwDashboardAction({type: "NW_DASHBOARD_IS_MODAL", payload: {isModal: false}})}/>
            {type === "add" ?
                <><AddTeamForm mutateTeams={mutateTeams}/></>
                :
                <>
                {nwDashboardContext.isModal && <UpdateTeamForm team={team} mutateTeam={mutateTeam} mutateTeamOverview={mutateTeamOverview}/>}
                </>
            }
        </div>
        </>
    )
}